import type { AdventureSnapshotListItem } from '../types';

/** Scene id for the developer playthrough snapshot picker menu. */
export const SNAPSHOT_MENU_SCENE_ID = 'snapshot_menu';

export function formatPlaythroughSnapshotLabel(snapshot: AdventureSnapshotListItem): string {
  const playerLabel = snapshot.playerCount === 1 ? '1 player' : `${snapshot.playerCount} players`;
  return `${snapshot.label} (${playerLabel})`;
}
